import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconLineBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLineBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '9f23cf6439e7747a941abfe491d08dcff7897f0f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1914b69c88176c8c6c65f05ba9f69a3e8dc12efe', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ccc20e188d7bc6adfe897daa74fa5840cd4adc53', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.942 2A4.06 4.06 0 0 1 20 6.058v9.884A4.06 4.06 0 0 1 15.942 20H6.058A4.06 4.06 0 0 1 2 15.942V6.058A4.06 4.06 0 0 1 6.058 2zm-4.944 3.282c-3.308 0-6 2.185-6 4.87 0 2.408 2.134 4.424 5.018 4.805.195.042.461.129.529.296.06.152.039.39.019.543-.003.014-.07.425-.086.513-.026.152-.12.594.52.324s3.456-2.035 4.715-3.484c.87-.954 1.287-1.922 1.287-2.997 0-2.685-2.693-4.87-6.002-4.87", fill: "#06C755" }), h("path", { key: 'e72b059d8250d156efd4cc4259992bc32610077b', d: "M15.003 11.703h-1.686a.115.115 0 0 1-.115-.115v-2.62c0-.062.052-.114.115-.114h1.686c.063 0 .114.052.114.115v.426a.115.115 0 0 1-.114.114h-1.146v.442h1.146c.063 0 .114.052.114.115v.425a.115.115 0 0 1-.114.115h-1.146v.442h1.146c.063 0 .114.051.114.114v.426a.115.115 0 0 1-.114.115m-6.237 0a.115.115 0 0 0 .115-.115v-.426a.115.115 0 0 0-.115-.114H7.62v-2.08a.115.115 0 0 0-.114-.114H7.08a.115.115 0 0 0-.114.115v2.619c0 .063.05.115.114.115zm1.015-2.849h-.425a.115.115 0 0 0-.115.115v2.619c0 .063.051.115.115.115h.425a.115.115 0 0 0 .115-.115v-2.62a.115.115 0 0 0-.115-.114m2.898 0h-.426a.115.115 0 0 0-.115.115v1.556L10.94 8.906l-.01-.012-.007-.008-.002-.002-.006-.005-.003-.002-.006-.004-.004-.002-.006-.004-.004-.002-.006-.003h-.004l-.007-.003-.004-.001-.007-.002h-.005l-.006-.001h-.433a.115.115 0 0 0-.115.114v2.619c0 .063.051.115.115.115h.425a.115.115 0 0 0 .115-.115v-1.555l1.2 1.62a.1.1 0 0 0 .038.034l.003.002.006.003.005.002.004.002.008.002h.001q.015.005.03.005h.424a.115.115 0 0 0 .114-.115v-2.62a.115.115 0 0 0-.114-.114", fill: "#06C755" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-line-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-line-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-line-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLineBranded$1);
            }
            break;
    } });
}

const CosmosIconLineBranded = CosmosIconLineBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLineBranded, defineCustomElement };
